<template>
  <div class="custom-alerts alert alert-warning fade in">
    <i class="fa-lg fa fa-warning" /> {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: 'You do not have authorisation for this action. Please contact an administrator for access.',
      type: String,
    },
  },
};
</script>
